import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';
import { useState } from 'react';
import PopoverEditarEstagio from './PopoverEditarEstagio';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function PipileneStageItem({
  funil,
  onDelete,
  user,
  cliente,
  onCallback,
  isDragging,
}) {
  const [pipelineId, setPipelineId] = useState(null);
  const [pipelineStage, setPipelineStage] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className={`${D.pipelineStage} ${isDragging ? D.pipelineStageDragging : ''}`}>
      <PopoverEditarEstagio
        id={id}
        cliente={cliente}
        user={user}
        pipelineId={pipelineId}
        anchorEl={anchorEl}
        pipelineStage={pipelineStage}
        open={open}
        onClose={() => setAnchorEl(null)}
        onCallback={() => {
          onCallback();
          setAnchorEl(null);
        }}
      />
      <span className="truncate flex-1 min-w-0" title={funil.nome}>{funil.nome}</span>
      <div className="flex items-center gap-0.5 flex-shrink-0">
        <button
          type="button"
          className="inline-flex items-center justify-center w-6 h-6 rounded-md text-[#a1a1aa] hover:text-[#18181b] hover:bg-[#f4f4f7] transition-colors"
          aria-label="Editar estágio"
          onClick={(event) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
            setPipelineId(funil._id);
            setPipelineStage(funil);
          }}
        >
          <Iconify icon="eva:edit-2-outline" width={12} />
        </button>
        <button
          type="button"
          className="inline-flex items-center justify-center w-6 h-6 rounded-md text-[#a1a1aa] hover:text-[#b42318] hover:bg-[#fef3f2] transition-colors"
          aria-label="Excluir estágio"
          onClick={(event) => {
            event.stopPropagation();
            onDelete(funil);
          }}
        >
          <Iconify icon="eva:trash-2-outline" width={12} />
        </button>
      </div>
    </div>
  );
}

PipileneStageItem.propTypes = {
  funil: PropTypes.object,
  onDelete: PropTypes.func,
  user: PropTypes.object,
  cliente: PropTypes.object,
  onCallback: PropTypes.func,
  isDragging: PropTypes.bool,
};
